// @flow

import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';

import { Colors, Metrics } from '../themes';

const Wrapper = styled.div`
  width: 100%;
`;

const Text = styled.h4`
  padding: 0;
  margin: 0;
  margin-bottom: ${Metrics.smallMargin}px;
`;

type Props = {
  label: string,
  confirmationQuestionText: string,
  confirmText: string,
  cancelText: string,

  onConfirmation: () => mixed,
};

type State = {
  isConfirming: boolean,
};

class DeleteButton extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isConfirming: false,
    };
  }

  onToggle = (): void => {
    this.setState({ isConfirming: !this.state.isConfirming });
  }

  render() {
    return (
      <Wrapper>
        {this.state.isConfirming && <Text style={{ marginTop: Metrics.margin }}>{this.props.confirmationQuestionText}</Text>}
        {!this.state.isConfirming &&
          <RaisedButton
            style={{ width: '40%' }}
            onClick={this.onToggle}
            label={this.props.label}
            buttonStyle={{ backgroundColor: Colors.decreaseStats }}
            labelStyle={{ color: Colors.tertiaryText }}
          />
        }
        {this.state.isConfirming &&
          <div>
            <RaisedButton
              label={this.props.confirmText}
              onClick={this.props.onConfirmation}
              buttonStyle={{ backgroundColor: Colors.decreaseStats }}
              labelStyle={{ color: Colors.tertiaryText }}
            />
            <RaisedButton
              style={{ marginLeft: Metrics.margin }}
              label={this.props.cancelText}
              onClick={this.onToggle}
            />
          </div>
        }
      </Wrapper>
    );
  }
}

export default DeleteButton;



// WEBPACK FOOTER //
// ./src/statsradio/components/DeleteButton.js